import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './Patient/home/home.component';
import { HcphomeComponent } from './hcp/hcphome/hcphome.component';
import { CookiespolicyComponent } from './cookiespolicy/cookiespolicy.component';
import { RedirectGuard } from './app.redirectguard';

const routes: Routes = [
  { path: '',
    canActivate: [RedirectGuard],
    component: RedirectGuard,
    data: {
      externalUrl: 'https://www.andembry.com'
    }
  },
  { path: 'patient',
    canActivate: [RedirectGuard],
    component: RedirectGuard,
    data: {
      externalUrl: 'https://www.andembry.com'
    }
  },
  { path: 'hcp', 
    canActivate: [RedirectGuard],
    component: RedirectGuard,
    data: {
      externalUrl: 'https://www.andembryhcp.com'
    }
  },
  { path: 'cookie-policy', 
    canActivate: [RedirectGuard],
    component: RedirectGuard,
    data: {
      externalUrl: 'https://www.andembry.com'
    }
  },
  { path: 'qr-event',
    canActivate: [RedirectGuard],
    component: RedirectGuard,
    data: {
      externalUrl: 'https://www.andembry.com'
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
